const MOBILE_MAX_WIDTH: number = 768;
const TABLET_MAX_WIDTH: number = 1280;

export {
    MOBILE_MAX_WIDTH,
    TABLET_MAX_WIDTH,
};
